import StandsPage from "./stands-page";
import StandPage from "./stand-page";
import StandKeysPage from "./stand-keys-page";
import StandLogPage from "./stand-log-page";
import StandCommentsPage from "./stand-comments-page";


const StandPages = {
    Collection : StandsPage,
    Single     : StandPage,
    Keys       : StandKeysPage,
    Log        : StandLogPage,
    Comments   : StandCommentsPage
};

export default StandPages;
